import React, { useEffect, useState } from "react";

import { buildFallbackLabel } from "../utils";


export default function ProductGallery({ product }) {
  const images = product?.images?.length
    ? product.images
    : product?.primary_image
      ? [{ id: "primary", image_url: product.primary_image, alt_text: product.name }]
      : [];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [product?.id]);

  const activeImage = images[activeIndex];

  return (
    <div className="store-gallery">
      <div className="store-gallery-stage">
        {activeImage ? (
          <img src={activeImage.image_url} alt={activeImage.alt_text || product.name} />
        ) : (
          <div className="store-gallery-fallback">{buildFallbackLabel(product?.name)}</div>
        )}
      </div>

      {images.length > 1 ? (
        <div className="store-gallery-strip">
          {images.map((image, index) => (
            <button
              className={index === activeIndex ? "active" : ""}
              key={image.id}
              onClick={() => setActiveIndex(index)}
              type="button"
            >
              <img src={image.image_url} alt={image.alt_text || product.name} />
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

